<script>
export default {
  methods: {},
  props: {
    selected: Boolean,
    hover: Boolean,
  },
  data: function () {
    return {};
  },
  computed: {},
};
</script>
    
<template>
  <div
    class="f-radio-button"
    :class="{ selected, hover }"
    @click="$emit('click', $event)"
  >
    <div class="f-dot" v-if="selected"></div>
  </div>
</template>

<style lang="scss" scoped>
.f-radio-button {
  width: 20px;
  height: 20px;
  border: 2px solid var(--blue);
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;

  &:hover,
  &.hover {
    border: 2px solid var(--blue-d100);
  }

  &:hover:active {
    border: 2px solid var(--blue-d90);
  }

  .f-dot {
    width: 12px;
    height: 12px;
    background-color: var(--blue);
    border-radius: 100%;
  }
}
</style>